export const situationCodes = [
    { code: '91', label: '91 — TERMINADO - REPARADO E ENVIADO', description: 'O equipamento foi reparado e devolvido ao cliente' },
    { code: '93', label: '93 — TERMINADO - NÃO REPARADO E ENVIADO', description: 'O equipamento foi devolvido ao cliente sem ser reparado' },
    { code: '94', label: '94 — TERMINADO - PROCESSADA SUBSTITUIÇÃO NA OFICINA', description: 'Terminado e a oficina processa a substituição do equipamento' },
    { code: '96', label: '96 — TERMINADO - AVISO ANULADO', description: 'O aviso/reclamação foi anulado' },
    { code: '97', label: '97 — TERMINADO - IRREPARÁVEL EQUIPAMENTO PARA PEÇAS', description: 'O equipamento é irreparável e a oficina fica com ele para peças' },
];

export default {
    situationCodes,
};